module.exports = __webpack_public_path__ + "node_modules/icheck/skins/futurico/futurico.png?6312475b";